import { Entity, stringifyEntityRef } from '@backstage/catalog-model';
import useSWR from 'swr';
import { FeatureFlag } from '../featureFlags';
import { AsyncFlagResult } from './useFeatureFlagUserVariation';
import { useOptionalLDClient } from './useOptionalLDClient';

export function useFeatureFlagEntityVariation(
  flag: FeatureFlag,
  entity: Entity,
): AsyncFlagResult {
  const ldClient = useOptionalLDClient();

  const { data, error } = useSWR(flag, async () => {
    if (!ldClient) {
      return false;
    }

    const launchDarklyContext = {
      kind: 'aura-portal-entity',
      key: stringifyEntityRef(entity),
      backstageKind: entity.kind,
      backstageType: entity.spec?.type,
      name: entity.metadata.name,
      lifecycle: entity.spec?.lifecycle,
      annotations: entity.metadata.annotations,
    };

    const current = ldClient.getContext?.();

    // only re-identify if different - to make mocking flags during tests possible
    const shouldSwitch =
      !current ||
      (current as any).key !== launchDarklyContext.key ||
      (current as any).kind !== launchDarklyContext.kind;

    if (shouldSwitch) {
      await ldClient.identify(launchDarklyContext);
    }

    return ldClient.variation(flag, false);
  });

  if (error) {
    return { error, loading: false, enabled: false };
  }
  if (data === undefined) {
    return { loading: true, enabled: false };
  }
  return { loading: false, enabled: Boolean(data) };
}
